/**
 * Wolfwalker Three.js coordinate transform for Drillz absolute ENU scene data.
 * X=east, Y=up (elevation), Z=north — matches rasterTerrain + legacy GLTF placement.
 */
import * as THREE from 'three';

/** Fixed scene origin (must match DrillHole3DViewer SCENE_FIXED_ORIGIN). */
export const SCENE_FIXED_ORIGIN = Object.freeze({
  easting: 384700,
  northing: 6944700,
  elevation: 0,
});

/**
 * @param {number} e Easting
 * @param {number} n Northing
 * @param {number} z Elevation
 * @param {{ easting: number, northing: number, elevation?: number }} [anchor=SCENE_FIXED_ORIGIN]
 * @returns {{ x: number, y: number, z: number }}
 */
export function toThreeCoords(e, n, z, anchor = SCENE_FIXED_ORIGIN) {
  const Ox = anchor.easting;
  const Oy = anchor.northing;
  const Oz = anchor.elevation ?? 0;
  return {
    x: e - Ox,
    y: z - Oz,
    z: n - Oy,
  };
}

/**
 * @param {[number, number, number]} pos
 * @param {{ easting: number, northing: number, elevation?: number }} [anchor]
 * @returns {THREE.Vector3}
 */
export function enuToVector3(pos, anchor = SCENE_FIXED_ORIGIN) {
  const { x, y, z } = toThreeCoords(pos[0], pos[1], pos[2], anchor);
  return new THREE.Vector3(x, y, z);
}

/**
 * Collar world object for terrain ROI from scene collar.
 * @param {{ position: [number, number, number] }} collar
 */
export function collarToWorld(collar) {
  const [e, n, z] = collar.position;
  return { easting: e, northing: n, elevation: z };
}

/**
 * @param {Array<{ position: [number, number, number], holeId?: string }>} collars
 * @param {string|null} selectedHoleId
 */
export function findSelectedCollar(collars, selectedHoleId) {
  if (!collars?.length) return null;
  if (selectedHoleId) {
    const match = collars.find((c) => c.holeId === selectedHoleId);
    if (match) return match;
  }
  return collars[0];
}
